import type { PreOrderEmail } from "@stockline/shared/types/orders/pre-order-email"
import type { OfflineResourceConfig } from "../../../types"
import { PRE_ORDER_EMAIL_TABLE } from "./db"

export const preOrderEmailConfig: OfflineResourceConfig<PreOrderEmail> = {
  name: "pre-order-emails",
  // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
  // scope change (STK-1238).
  groupScoped: true,
  // HOT via the parent pre-order (server floor by parent JOIN). STK-1322.
  tier: "hot",
  windowedBy: "pre-orders",
  window: { days: 30 },
  endpoints: {
    full: "/api/v2/pre-order-emails",
    delta: "/api/v2/pre-order-emails/changes",
    push: "/api/v2/pre-order-emails/changes",
  },
  tableName: PRE_ORDER_EMAIL_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    preOrderId: "preOrderId",
    emailId: "emailId",
    deletedAt: "deletedAt",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
